module.exports = __webpack_public_path__ + "img/W-G27.48f97062.jpg";